import React from 'react';

export default function InventoryId({width = 16, height = 16, color = '#000000'})
{
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.66699 6H13.3337" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.66699 10H13.3337" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.66634 2L5.33301 14" stroke={color} strokeWidth="1.16667" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M10.6663 2L9.33301 14" stroke={color} strokeWidth="1.16667" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
  );
}
